import { createNullableProvideInject } from '@collector/shared-ui'
import { UseEventClock } from '@collector/shared-ui-domain'

export const [provideEventClock, injectEventClock] =
  createNullableProvideInject<UseEventClock>('eventClock')
